// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ClaimType,
    ObjectNoResponse,
    ProviderReportItem,
    QuicksightEmbedUrl,
    SpanType,
    SupportCreateQuicksightConfigurationPayload,
    SupportQuicksightConfiguration,
    SupportCreateQuicksightConfigurationPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderReportItemFromJSON,
    QuicksightEmbedUrlFromJSON,
    SupportQuicksightConfigurationFromJSON,
} from '../models';

export interface CreateSupportQuicksightConfigurationRequest {
    supportCreateQuicksightConfigurationPayload: SupportCreateQuicksightConfigurationPayload;
}

export interface GetClaimSubmittedReportRequest {
    start: string;
    end: string;
    span: SpanType;
    claimType: ClaimType;
}

export interface GetExpectedRateReportRequest {
    start: string;
    end: string;
    span: SpanType;
    claimType: ClaimType;
}

export interface GetGrossCollectionsReportRequest {
    start: string;
    end: string;
    span: SpanType;
    claimType: ClaimType;
}

export interface GetPatientCollectionsReportRequest {
    start: string;
    end: string;
    span: SpanType;
    claimType: ClaimType;
}

export interface GetPayerMixReportRequest {
    start: string;
    end: string;
    claimType: ClaimType;
}

export interface GetPracticeSummaryReportRequest {
    start: string;
    end: string;
    span: SpanType;
    claimType: ClaimType;
}

/**
 * no description
 */
export class ReportApi extends runtime.BaseAPI {

    /**
     * Create the quicksight configuration
     * Create the quicksight configuration
     */
    async createSupportQuicksightConfigurationRaw(requestParameters: CreateSupportQuicksightConfigurationRequest): Promise<runtime.ApiResponse<SupportQuicksightConfiguration>> {
        if (requestParameters['supportCreateQuicksightConfigurationPayload'] === null || requestParameters['supportCreateQuicksightConfigurationPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateQuicksightConfigurationPayload','Required parameter requestParameters.supportCreateQuicksightConfigurationPayload was null or undefined when calling createSupportQuicksightConfiguration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "create:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/report/quicksight`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateQuicksightConfigurationPayloadToJSON(requestParameters['supportCreateQuicksightConfigurationPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportQuicksightConfigurationFromJSON(jsonValue));
    }

    /**
     * Create the quicksight configuration
     * Create the quicksight configuration
     */
    async createSupportQuicksightConfiguration(requestParameters: CreateSupportQuicksightConfigurationRequest): Promise<SupportQuicksightConfiguration> {
        const response = await this.createSupportQuicksightConfigurationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Deletes the quicksight configuration
     * Deletes the quicksight configuration
     */
    async deleteSupportQuicksightConfigurationRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "delete:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/report/quicksight`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Deletes the quicksight configuration
     * Deletes the quicksight configuration
     */
    async deleteSupportQuicksightConfiguration(): Promise<ObjectNoResponse> {
        const response = await this.deleteSupportQuicksightConfigurationRaw();
        return await response.value();
    }

    /**
     * Get a claims submitted report
     * Get a claims submitted report
     */
    async getClaimSubmittedReportRaw(requestParameters: GetClaimSubmittedReportRequest): Promise<runtime.ApiResponse<Array<ProviderReportItem>>> {
        if (requestParameters['start'] === null || requestParameters['start'] === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getClaimSubmittedReport.');
        }

        if (requestParameters['end'] === null || requestParameters['end'] === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling getClaimSubmittedReport.');
        }

        if (requestParameters['span'] === null || requestParameters['span'] === undefined) {
            throw new runtime.RequiredError('span','Required parameter requestParameters.span was null or undefined when calling getClaimSubmittedReport.');
        }

        if (requestParameters['claimType'] === null || requestParameters['claimType'] === undefined) {
            throw new runtime.RequiredError('claimType','Required parameter requestParameters.claimType was null or undefined when calling getClaimSubmittedReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.span !== undefined) {
            queryParameters['span'] = requestParameters.span;
        }

        if (requestParameters.claimType !== undefined) {
            queryParameters['claimType'] = requestParameters.claimType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/submitted`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReportItemFromJSON));
    }

    /**
     * Get a claims submitted report
     * Get a claims submitted report
     */
    async getClaimSubmittedReport(requestParameters: GetClaimSubmittedReportRequest): Promise<Array<ProviderReportItem>> {
        const response = await this.getClaimSubmittedReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an expected rate report
     * Get an expected rate report
     */
    async getExpectedRateReportRaw(requestParameters: GetExpectedRateReportRequest): Promise<runtime.ApiResponse<Array<ProviderReportItem>>> {
        if (requestParameters['start'] === null || requestParameters['start'] === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getExpectedRateReport.');
        }

        if (requestParameters['end'] === null || requestParameters['end'] === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling getExpectedRateReport.');
        }

        if (requestParameters['span'] === null || requestParameters['span'] === undefined) {
            throw new runtime.RequiredError('span','Required parameter requestParameters.span was null or undefined when calling getExpectedRateReport.');
        }

        if (requestParameters['claimType'] === null || requestParameters['claimType'] === undefined) {
            throw new runtime.RequiredError('claimType','Required parameter requestParameters.claimType was null or undefined when calling getExpectedRateReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.span !== undefined) {
            queryParameters['span'] = requestParameters.span;
        }

        if (requestParameters.claimType !== undefined) {
            queryParameters['claimType'] = requestParameters.claimType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/expected`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReportItemFromJSON));
    }

    /**
     * Get an expected rate report
     * Get an expected rate report
     */
    async getExpectedRateReport(requestParameters: GetExpectedRateReportRequest): Promise<Array<ProviderReportItem>> {
        const response = await this.getExpectedRateReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a gross collections report
     * Get a gross collections report
     */
    async getGrossCollectionsReportRaw(requestParameters: GetGrossCollectionsReportRequest): Promise<runtime.ApiResponse<Array<ProviderReportItem>>> {
        if (requestParameters['start'] === null || requestParameters['start'] === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getGrossCollectionsReport.');
        }

        if (requestParameters['end'] === null || requestParameters['end'] === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling getGrossCollectionsReport.');
        }

        if (requestParameters['span'] === null || requestParameters['span'] === undefined) {
            throw new runtime.RequiredError('span','Required parameter requestParameters.span was null or undefined when calling getGrossCollectionsReport.');
        }

        if (requestParameters['claimType'] === null || requestParameters['claimType'] === undefined) {
            throw new runtime.RequiredError('claimType','Required parameter requestParameters.claimType was null or undefined when calling getGrossCollectionsReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.span !== undefined) {
            queryParameters['span'] = requestParameters.span;
        }

        if (requestParameters.claimType !== undefined) {
            queryParameters['claimType'] = requestParameters.claimType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/gross`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReportItemFromJSON));
    }

    /**
     * Get a gross collections report
     * Get a gross collections report
     */
    async getGrossCollectionsReport(requestParameters: GetGrossCollectionsReportRequest): Promise<Array<ProviderReportItem>> {
        const response = await this.getGrossCollectionsReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a patient collections report
     * Get a patient collections report
     */
    async getPatientCollectionsReportRaw(requestParameters: GetPatientCollectionsReportRequest): Promise<runtime.ApiResponse<Array<ProviderReportItem>>> {
        if (requestParameters['start'] === null || requestParameters['start'] === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getPatientCollectionsReport.');
        }

        if (requestParameters['end'] === null || requestParameters['end'] === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling getPatientCollectionsReport.');
        }

        if (requestParameters['span'] === null || requestParameters['span'] === undefined) {
            throw new runtime.RequiredError('span','Required parameter requestParameters.span was null or undefined when calling getPatientCollectionsReport.');
        }

        if (requestParameters['claimType'] === null || requestParameters['claimType'] === undefined) {
            throw new runtime.RequiredError('claimType','Required parameter requestParameters.claimType was null or undefined when calling getPatientCollectionsReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.span !== undefined) {
            queryParameters['span'] = requestParameters.span;
        }

        if (requestParameters.claimType !== undefined) {
            queryParameters['claimType'] = requestParameters.claimType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/patient`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReportItemFromJSON));
    }

    /**
     * Get a patient collections report
     * Get a patient collections report
     */
    async getPatientCollectionsReport(requestParameters: GetPatientCollectionsReportRequest): Promise<Array<ProviderReportItem>> {
        const response = await this.getPatientCollectionsReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a payer mix report
     * Get a payer mix report
     */
    async getPayerMixReportRaw(requestParameters: GetPayerMixReportRequest): Promise<runtime.ApiResponse<Array<ProviderReportItem>>> {
        if (requestParameters['start'] === null || requestParameters['start'] === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getPayerMixReport.');
        }

        if (requestParameters['end'] === null || requestParameters['end'] === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling getPayerMixReport.');
        }

        if (requestParameters['claimType'] === null || requestParameters['claimType'] === undefined) {
            throw new runtime.RequiredError('claimType','Required parameter requestParameters.claimType was null or undefined when calling getPayerMixReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.claimType !== undefined) {
            queryParameters['claimType'] = requestParameters.claimType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/payer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReportItemFromJSON));
    }

    /**
     * Get a payer mix report
     * Get a payer mix report
     */
    async getPayerMixReport(requestParameters: GetPayerMixReportRequest): Promise<Array<ProviderReportItem>> {
        const response = await this.getPayerMixReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a practice summary report
     * Get a practice summary report
     */
    async getPracticeSummaryReportRaw(requestParameters: GetPracticeSummaryReportRequest): Promise<runtime.ApiResponse<Array<ProviderReportItem>>> {
        if (requestParameters['start'] === null || requestParameters['start'] === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getPracticeSummaryReport.');
        }

        if (requestParameters['end'] === null || requestParameters['end'] === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling getPracticeSummaryReport.');
        }

        if (requestParameters['span'] === null || requestParameters['span'] === undefined) {
            throw new runtime.RequiredError('span','Required parameter requestParameters.span was null or undefined when calling getPracticeSummaryReport.');
        }

        if (requestParameters['claimType'] === null || requestParameters['claimType'] === undefined) {
            throw new runtime.RequiredError('claimType','Required parameter requestParameters.claimType was null or undefined when calling getPracticeSummaryReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.span !== undefined) {
            queryParameters['span'] = requestParameters.span;
        }

        if (requestParameters.claimType !== undefined) {
            queryParameters['claimType'] = requestParameters.claimType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/practice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReportItemFromJSON));
    }

    /**
     * Get a practice summary report
     * Get a practice summary report
     */
    async getPracticeSummaryReport(requestParameters: GetPracticeSummaryReportRequest): Promise<Array<ProviderReportItem>> {
        const response = await this.getPracticeSummaryReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the quicksight embed url
     * Get the quicksight embed url
     */
    async getProviderQuicksightUrlRaw(): Promise<runtime.ApiResponse<QuicksightEmbedUrl>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/report/quicksight/url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => QuicksightEmbedUrlFromJSON(jsonValue));
    }

    /**
     * Get the quicksight embed url
     * Get the quicksight embed url
     */
    async getProviderQuicksightUrl(): Promise<QuicksightEmbedUrl> {
        const response = await this.getProviderQuicksightUrlRaw();
        return await response.value();
    }

    /**
     * Get the quicksight configuration
     * Get the quicksight configuration
     */
    async getSupportQuicksightConfigurationRaw(): Promise<runtime.ApiResponse<SupportQuicksightConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/report/quicksight`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportQuicksightConfigurationFromJSON(jsonValue));
    }

    /**
     * Get the quicksight configuration
     * Get the quicksight configuration
     */
    async getSupportQuicksightConfiguration(): Promise<SupportQuicksightConfiguration> {
        const response = await this.getSupportQuicksightConfigurationRaw();
        return await response.value();
    }

    /**
     * Get the quicksight embed url
     * Get the quicksight embed url
     */
    async getSupportQuicksightUrlRaw(): Promise<runtime.ApiResponse<QuicksightEmbedUrl>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:report"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/report/quicksight/url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => QuicksightEmbedUrlFromJSON(jsonValue));
    }

    /**
     * Get the quicksight embed url
     * Get the quicksight embed url
     */
    async getSupportQuicksightUrl(): Promise<QuicksightEmbedUrl> {
        const response = await this.getSupportQuicksightUrlRaw();
        return await response.value();
    }

}
